import { appConfig } from "@/constants";
import { RuleId } from "@/domain/gems-game/domain/lib/LatestEarnings";
import { Quest as MainQuest } from "@/domain/gems-game/domain/lib/Quest";
import { EarningType } from "@/domain/gems-game/domain/lib/Quest";
import { QuestTileType } from "@/domain/gems-game/domain/lib/TileType";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

export const immortalRisingMainQuest = new MainQuest({
  id: RuleId.IMMORTAL_RISING,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Register for the Immortal Statue NFT Collection Whitelist",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z8FD_57c43Q3gWAk_Pl8k9woQ_400x400.jpg?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z7-9557c43Q3gSSo_IR_Level_3.png?auto=format,compress",
  ),
  gemsAmount: "50",
  analyticsId: "immortal-rising-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OffChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      `Complete the <a href="https://immortalrising2.com/game" target="_blank" rel="noreferrer">Immortal Statue NFT Collection Whitelist Application Form</a>`,
    ],
  },
  // start date should be 26th of Feb 00.00 UTC
  startDate: new Date("2025-02-27T09:00:00Z"),
  // end date should be 26th of Marth 00.00 UTC
  endDate: new Date("2025-03-06T09:00:00Z"),
  // estimate completion time should be 5 minutes
  estimateCompletionTime: "5 minutes",
  availableOn: ["iOS", "Android"],
  registerUrl: new URL("https://immortalrising2.com/game"),
});

const immortalRisingQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-wishlist-added",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/webm",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/immortal-rising/ImmortalRising2Trailer.webm`,
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-trailer-watched",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    skippable: true,
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join Immortal Rising 2's massively growing community",
    linkUrl: "https://discord.com/invite/immortalrising2",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-discord-followed",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-discord",
  },
  {
    type: "link",
    key: "x-v2",
    skippable: false,
    icon: "X",
    label: "Follow Immortal Rising 2 on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/immortalrising2",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-twitter-followed",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-twitter",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Download and Play Immortal Rising 2",
    caption: "Download the game and dive in!",
    linkUrl: "https://immortalrising2.com/game",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-website-1-visited",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-website-1",
  },
];

const immortalRisingQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Complete Immortal Rising 2 Missions for more rewards",
    caption: "",
    linkUrl: "https://immortalrising2.com/mission",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-website-2-visited",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-website-2",
    waitTimeInHrs: 24,
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-onboarding-completed",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-onboarding",
  },
];

const immortalRisingQuestsLvl3: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "Document",
    label: "Learn about the IR2 economy",
    caption: "",
    linkUrl: "https://immortalrising2.com/tokens",
    increase: 25,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-website-3-event",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-website-3",
    waitTimeInHrs: 24,
  },
  {
    type: "link",
    key: "website",
    icon: "X",
    label: "Post about it on X",
    caption: "",
    linkUrl:
      "https://twitter.com/intent/tweet?text=Before%20the%20kingdom%2C%20there%20was%20the%20gate.%20%F0%9F%8C%81%0A%0AJust%20hit%20Level%203%20in%20%40Immortalrising2%2C%20one%20of%20the%20fastest%20growing%20web3%20mobile%20RPGs%2C%20earning%20%40Immutable%20Gems!%0A%0ALocked%20in%20for%20March%2018%20Statue%20NFT%20Collection!%0A%0APlay%3A%20https%3A%2F%2Fplay.immutable.com%2Fgames%2Fimmortal-rising-2%2F",
    increase: 25,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-website-4-event",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-website-4",
    waitTimeInHrs: 0,
  },
];

const immortalRisingQuestsLvl4: Quest[] = [
  {
    type: "custom",
    key: "bonus-variant-2",
    icon: "Edit",
    label: "Acquire a Immortal Rising 2 Statue",
    linkUrl: "https://tokentrove.com/collection/ImmortalRising2Statues",
    caption: "",
    increase: 50,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "96191677-0a86-4718-a863-d8e7818fc063-never-compeletes",
    ruleId: "96191677-0a86-4718-a863-d8e7818fc063-fake",
    waitTimeInHrs: 0,
  },
];

export const immortalRisingQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +30 <icon> Gems",
    totalGemsGranted: 30,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: immortalRisingQuestsLvl1,
    introModal: {
      title: "You are on your way to Level 1",
      description:
        "Thanks for following <name>. Keep showing your support and earn better perks while doing it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z4WalJbqstJ99Zyk_IR_1.png?auto=format,compress",
    },
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Contribute to the lore",
      description: "Level 2 Believer",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +<increase> <icon> Gems",
    totalGemsGranted: 20,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: immortalRisingQuestsLvl2,
    introModal: {
      title: "Level 2, here you go",
      description:
        "People like you are making <name> a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z4WalJbqstJ99Zyl_IR_2.png?auto=format,compress",
    },
  },
  {
    key: "level-3",
    header: {
      image: "",
      title: "Dive deeper into the game economy",
      description: "Level 3 Supporter",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +<increase> <icon> Gems",
    totalGemsGranted: 50,
    hideOnCompletion: false,
    lockedUntilPrevious: true,
    quests: immortalRisingQuestsLvl3,
    introModal: {
      title: "You've reached Level 3",
      description: "Let's dive into what makes Immortal Rising 2 so exciting.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z7-9557c43Q3gSSo_IR_Level_3.png?auto=format,compress",
    },
    exitModal: {
      title: "That's all folks",
      description:
        "Level 3 Supporter achieved. Bigger and better quests are on the horizon!",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z4WalZbqstJ99Zym_IR_3.png?auto=format,compress",
    },
  },
  {
    key: "level-4",
    header: {
      image: "",
      title: "Immortal Statue NFT Collection",
      description: "Bonus Level",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +<increase> <icon> Gems",
    totalGemsGranted: 50,
    hideOnCompletion: false,
    lockedUntilPrevious: false,
    quests: immortalRisingQuestsLvl4,
  },
];
